import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { Icon } from "../../../Icons/Icon";

export const PinIcon = styled(Icon)<{ pinned?: boolean }>(props => ({
    display: "inline-block",
    position: "absolute",
    color: theme(props).typography.secondary.color,
    transition: `transform 0.1s ease`,
    top: 7,
    left: 8,
    transform: props.pinned ? `rotate(-45deg)` : `rotate(45deg)`,
}));

export const PinRoot = styled.button(props => ({
    display: "inline-block",
    width: theme(props).size(4),
    height: theme(props).size(4),
    borderRadius: theme(props).size(2),
    outline: 0,
    border: 0,
    padding: 0,
    boxSizing: "border-box",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "transparent",

    ":hover": {
        backgroundColor: theme(props).keyPalette.panel2BackgroundColorAsBlackTransparent,
    },
}));
